//import Index from '@/pages/Sellpoint/Index'
// import Sellpoint from '@/pages/Sellpoint/Sellpoint'
// export default {
//   path: '/:id',
//   name: 'Sellpoint',
//   component: Sellpoint
// }

// import Product from '@/pages/Sellpoint/Product'

// export default {
//     path: '/:id',
//     component: Sellpoint,
//     children: [
//       {
//         path: '',
//         name: 'Sellpoint',
//         component: Sellpoint
//       },
     
//     ]
// }

import Product from '@/pages/Sellpoint/Product'
import Sellpoint from '@/pages/Sellpoint/Sellpoint'
import SellpointTemplate from '@/pages/Sellpoint/SellpointTemplate'
export default {
    path: '/:id',
    component: SellpointTemplate,
    children: [
      {
        path: '',
        name: 'Sellpoint',
        component: Sellpoint
      },
      {
        path: ':id1',
        name: 'Product',
        component: Product,
      },
     
    ]
}



// WEBPACK FOOTER //
// ./src/router/sellpoint.js